module.exports = __webpack_public_path__ + "static/media/token.7f41b3b3.png";